import { tableBetSliceActions } from '@/modules/betTable/slice';
import { SupportedGameResult } from '@/modules/host/models';
import { hostsSliceActions } from '@/modules/host/slice';
import {
    getHostLiveDataByHostId,
    hostLiveSliceActions,
} from '@/modules/hostLive/slice';
import store from '@/store/store';
import { updateRemainTime } from '@/utils/commonFunc';
import { Dispatch } from 'react';
import { Action } from 'redux';
import { CMDScNewBlackjackBetting, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDScNewBlackjackBettingHandler extends AbstractHandler {
    _command: CMDScNewBlackjackBetting;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScNewBlackjackBetting;
    }
    override handle(dispatch: Dispatch<Action>): void {
        const newResult = {} as SupportedGameResult;
        const state = store.getState();
        // const { PlayerID } = getMainUserState(state);
        // const host = getHostById(state, this._command.HostID);
        const hostLiveData = getHostLiveDataByHostId(
            state,
            this._command.HostID
        );

        hostLiveData.ShuffleTimer && clearTimeout(hostLiveData.ShuffleTimer);
        dispatch(
            hostLiveSliceActions.startBet({
                hostId: this._command.HostID,
                result: hostLiveData.CurrentResult
                    ? hostLiveData.CurrentResult
                    : newResult,
                remainTime: updateRemainTime(this._command.CountDown),
                countDown: this._command.CountDown,
                pendingTime: 0, //no kickplayer period, no need
                canLeave: true,
            })
        );
        dispatch(
            hostsSliceActions.startBet({
                hostId: this._command.HostID,
                result: hostLiveData.CurrentResult
                    ? hostLiveData.CurrentResult
                    : newResult,
                remainTime: updateRemainTime(this._command.CountDown),
                countDown: this._command.CountDown,
                pendingTime: 0, //no kickplayer period, no need
                canLeave: true,
            })
        );
        dispatch(
            tableBetSliceActions.startBet({
                hostId: this._command.HostID,
                gameId: this._command.GameID,
            })
        );
    }
}
